import {dashboardGeneticsRetrieveUniqueStateId} from './dashboard-genetics-retrieve.models';
import {GeneticData} from '../../types/dashboard-genetics-general.types';
import {GeneticFileProcessingStatus} from '../../types/dashboard-genetics-processing.types';
import {UnknownError} from '../../../shared/symbols';
import {User} from '../../../auth/symbols';

export class GetOwnGeneticStatus {
  static readonly type = `${dashboardGeneticsRetrieveUniqueStateId} ${GetOwnGeneticStatus.name}`;
}

export class GetOwnGeneticStatusSuccess {
  constructor(public userId: User[`uid`], public geneticStatuses: GeneticFileProcessingStatus[]) {}
  static readonly type = `${dashboardGeneticsRetrieveUniqueStateId} ${GetOwnGeneticStatusSuccess.name}`;
}

export class GetOwnGeneticStatusFail {
  static readonly type = `${dashboardGeneticsRetrieveUniqueStateId} ${GetOwnGeneticStatusFail.name}`;
  constructor(public error: UnknownError) {}
}

export class GetGeneticStatus {
  constructor(public userId: User[`uid`], public isSubmissionPublic: boolean) {}
  static readonly type = `${dashboardGeneticsRetrieveUniqueStateId} ${GetGeneticStatus.name}`;
}

export class GetGeneticStatusSuccess {
  constructor(public userId: User[`uid`], public isSubmissionPublic: boolean, public geneticStatuses: GeneticFileProcessingStatus[]) {}
  static readonly type = `${dashboardGeneticsRetrieveUniqueStateId} ${GetGeneticStatusSuccess.name}`;
}

export class GetGeneticStatusFail {
  static readonly type = `${dashboardGeneticsRetrieveUniqueStateId} ${GetGeneticStatusFail.name}`;
  constructor(public error: UnknownError) {}
}

export class LoadGeneticData {
  static readonly type = `${dashboardGeneticsRetrieveUniqueStateId} ${LoadGeneticData.name}`;
}

export class LoadGeneticDataSuccess {
  constructor(public geneticData: GeneticData) {}
  static readonly type = `${dashboardGeneticsRetrieveUniqueStateId} ${LoadGeneticDataSuccess.name}`;
}

export class LoadGeneticDataFail {
  static readonly type = `${dashboardGeneticsRetrieveUniqueStateId} ${LoadGeneticDataFail.name}`;

  constructor(public error: UnknownError) {
  }
}
